module.exports = __webpack_public_path__ + "img/home-53-hero_9x16_cn_poster.2de9542.jpg";